<template>
<div class="flex flex-col items-center justify-center min-h-full text-gray-800">
	<div class="flex flex-col flex-grow w-full max-w-xl bg-white shadow-xl overflow-hidden">
		<div id="list" ref="list" class="flex flex-col flex-grow h-0 p-4 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-200">
      <VueEternalLoading :load="loadMessages" position="top" :isInitial="true" :container="$refs.list">
        <template #no-more="{ retry }">
          <div class="hidden">&nbsp;</div>
        </template>
        <template #loading="{ isFirstLoad }">
          <div class="flex justify-center mb-5">
            <div class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full text-blue-600" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
        </template>
      </VueEternalLoading>
      <div class="flex flex-wrap w-full mt-2 space-x-3 max-w-xs" v-for="(message, index) in messages" :class="{'ml-auto': message.mine, 'justify-end': message.mine}">
        <span v-if="index == 0 || showDateTitle(messages[index - 1].createdAt) != showDateTitle(message.createdAt)" class="w-full text-center text-gray-500 pb-2 mb-2 border-b">
          {{ showDateTitle(message.createdAt) }}
        </span>
				<div>
          <ChatImage v-if="message?.type && message.type == 'image'" :message="message" />
          <ChatAudio v-else-if="message?.type && message.type == 'audio'" :message="message" />

          <template v-else>
            <div class="p-3" :class="{'bg-gray-300': !message.mine, 'rounded-r-lg': !message.mine, 'rounded-bl-lg': !message.mine, 'bg-blue-600': message.mine, 'rounded-l-lg': message.mine, 'rounded-br-lg': message.mine, 'text-white': message.mine}">
              <p class="text-sm">{{ message.text }}</p>
            </div>
            <span v-if="(index + 1) == messages.length || messages[index + 1].mine != message.mine || showDate(messages[index + 1].createdAt) != showDate(message.createdAt)" class="text-xs text-gray-500 leading-none">
              {{ showDate(message.createdAt) }}
            </span>
          </template>

				</div>
			</div>
		</div>
		
		<div class="bg-gray-300 p-4">
      <input type="file" accept="image/*" class="hidden" id="file" @change="submitImage" />
      <img ref="imagepreview" class="w-36 mb-3 mx-auto" />

      <div class="w-full flex gap-4 items-center">
        <label for="file" class="cursor-pointer p-1">
          <button type="button" class="text-base pointer-events-none">
            <font-awesome-icon icon="fa-solid fa-paperclip" class="text-xl pointer-events-none"></font-awesome-icon>
          </button>
        </label>
  
        <input 
          class="flex items-center h-10 w-3/4 md:w-full rounded px-3 text-sm" 
          type="text" 
          placeholder="escreva…" 
          v-model="message" 
          v-on:keyup.enter="submitMessage" />
        
        <button 
          type="button" 
          class="w-1/4 px-6 py-2.5 bg-blue-600 text-white font-roboto font-medium leading-tight uppercase rounded shadow-md ml-1 hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out" 
          @click.prevent="submitMessage"
          v-show="message.trim().length > 0">
            <font-awesome-icon icon="fa-paper-plane" class="text-white text-lg" />
        </button>

        <button 
          type="button" 
          class="w-1/4 px-6 py-2.5 bg-blue-600 text-white font-roboto font-medium leading-tight uppercase rounded shadow-md ml-1 hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
          v-show="message.trim().length == 0"
          @click="handleStartRecord">
            <font-awesome-icon icon="fa-microphone" class="text-white text-lg" v-show="!isRecording" />
            <font-awesome-icon icon="fa-stop" class="text-white text-lg" v-show="isRecording" />
        </button>
      </div>
		</div>
	</div>
  </div>
</template>
<script>
import fire from "./fire";
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import { uuid } from 'vue-uuid';
import { VueEternalLoading } from '@ts-pro/vue-eternal-loading';

import ChatImage from './ChatImage';
import ChatAudio from './ChatAudio';
import { getStorage, ref, uploadBytes } from 'firebase/storage'

export default {
  components: {
    uuid,
    VueEternalLoading,
    ChatImage,
    ChatAudio,
  },
  props: {
    room: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      audioRecord: null,
      isRecording: false,
      buffer: [],

      messages: [],
      image: null,
      message: '',
      page: 1,
      itemsPerPage: 100,
      loaded: null,
      noMore: null,
    };
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },

  methods: {
    handleStartRecord: function () {
      if ( !this.audioRecord )
        this.initAudioRecord()


      if ( !this.isRecording ) {
        this.audioRecord.start()
        this.isRecording = true
      }
      
      else {
        this.audioRecord.stop()
        this.isRecording = false
      }
    },

    initAudioRecord: async function () {
      if ( !( navigator.mediaDevices && navigator.mediaDevices.getUserMedia ) ) {
        console.log( 'seu navegador não suporta audio' )
        return
      }

      try {
        const audioStream = await navigator.mediaDevices.getUserMedia( { audio: true } )
        const audioRecord = new MediaRecorder( audioStream )

        this.audioRecord = audioRecord

        this.audioRecord.ondataavailable = blob => this.buffer.push( blob.data )

        this.audioRecord.onstop = () => {
          const audio = new Blob( this.buffer, { type: 'audio/ogg' } )

          const storage = getStorage( fire.app() )
          const audioRef = ref( storage, `audio/${ uuid.v1() }.ogg` )

          uploadBytes( audioRef, audio ).then( snapshot => {
            this.sendMessage( null, 'audio', snapshot.ref.name )
            this.buffer = []
          } )
        }
      }

      catch ( err ) {
        console.log( err )
      }
    },


    loadMessages({ loaded, noMore }) {
      this.loaded = loaded;
      this.noMore = noMore;
      fire.database().ref('messages/' + this.room.id).off("value", this._loadMessages);
      fire.database().ref('messages/' + this.room.id).orderByChild('createdAt').limitToLast(this.page * this.itemsPerPage).on("value", this._loadMessages);
      this.page++;
    },
    _loadMessages(_messages) {
      let totalOld = this.messages.length;
      let updates = {};
      this.messages = [];

      _messages.forEach((_message) => {
        let message = _message.val();
        let mine = false;
        let user_name = '';
        if(message.sender == this.user.id) {
          mine = true;
          user_name = this.user.name;
        } else {
          let sender_user = this.$parent.findUser(message.sender);
          user_name = sender_user.name;
          if(this.room.unreadMessages()?.indexOf(_message.key) >= 0) {
            updates[`user_room_messages_read/${this.user.id}/${this.room.id}/${_message.key}`] = null;
          }
        }

        this.messages.push({
          id: _message.key,
          user_name: user_name,
          mine: mine,
          src: message.src,
          type: message.type,
          text: message.text,
          createdAt: message.createdAt,
        });
      });

      if(Object.keys(updates).length) {
        fire.database().ref().update(updates);
      }

      let list_el = this.$refs.list;
      if(!totalOld) {
        setTimeout(function() {
          list_el.scrollTop = list_el.scrollHeight;
        }, 10);
      }

      if(totalOld != this.messages.length) {
        this.loaded();
      } else {
        this.noMore();
      }
    },
    submitMessage() {
      if ( this.image ) {
        const imageType = this.image.type.split( '/' )[ 1 ]

        const storage = getStorage( fire.app() )
        const imageRef = ref( storage, `images/${ uuid.v1() }.${ imageType }` )

        uploadBytes( imageRef, this.image ).then( snapshot => {
          this.sendMessage( this.message, 'image', snapshot.ref.name )
          this.message =  ''
          this.image = null
          this.$refs.imagepreview.src = ''
        } )
      }

      else if(this.message.length) {
        this.sendMessage(this.message, 'text', null);
        this.message = '';
      }
    },

    submitImage( $event ) {
      const file = $event.target.files[ 0 ]

      if ( !file ) {
        return
      }

      this.image = file
      this.$refs.imagepreview.src = URL.createObjectURL( this.image )
    },

    sendMessage(message, type, src) {
      let messageId = uuid.v1();
      let messageDate = fire.database.ServerValue.TIMESTAMP;

      let users = this.room.users;

      Object.keys(users).forEach((key, index) => {
        users[key] = true;
      });

      let updates = {};

      for(let i = 0; i < this.room.others.length; i++) {
        let otherUser = this.room.others[i];
        updates[`user_room_messages_read/${otherUser}/${this.room.id}/${messageId}`] = false;
      }

      updates[`messages/${this.room.id}/${messageId}`] = {
        createdAt: messageDate,
        sender: this.user.id,
        src,
        type,
        text: message,
      };

      updates[`rooms/${this.room.id}`] = {
        users: users,
        lastMessage: message,
        updatedAt: messageDate,
        createdAt: this.room.createdAt,
      };

      fire.database().ref().update(updates);
    },
    showDate(_date) {
      return this.$filters.formatDateTime(_date, 'HH:mm');
    },
    showDateTitle(_date) {
      let today = parseInt(this.$filters.formatDateTime(new Date(), 'yyyyMMdd'));
      let date = parseInt(this.$filters.formatDateTime(_date, 'yyyyMMdd'));
      if(today == date) {
        return 'Hoje';
      } else if(today == (date + 1)) {
        return 'Ontem';
      } else {
        return this.$filters.formatDate(_date);
      }
    },
  },
  mounted() {
    //fire.database().ref('messages/' + this.room.id).orderByChild('createdAt').limitToLast(this.page * this.itemsPerPage).on("value", this._loadMessages);
    //this.page++;
    this.initAudioRecord()
  },
  unmounted() {
    fire.database().ref('messages/' + this.room.id).off("value", this._loadMessages);
  }
}
</script>